import React from 'react'
import PropTypes from 'prop-types'
import { trackEvent } from '@blocket/tracking'
import ListItem from 'components/AdListItem/ListItem'

export const ToplistAdItem = (props) => {
  const formattedAd = {
    adStatus: 'active', // Hardcoded, since toplistings are probably always active
    advertiser: { type: 'store' }, // Hardcoded, since toplistings will probably always be from stores
    category: [{ name: props.categoryName || 'Bilar' }], // Todo: remove 'Bilar' when api is updated
    location: [{ name: props.location }],
    price: props.price,
    subject: props.subject,
    toplistingLabel: props.productLabel || 'Listettan', // Can also be 'Veckans bostad'/'Månadens nyproduction' and probably something else
    impressionUrl: props.impressionUrl,
    isToplisting: true,
  }

  const trackClick = () => {
    trackEvent({
      eventType: 'Engagement',
      eventCategory: 'search',
      eventAction: 'clicked listettan link',
      eventLabel: `listettan-click`,
      objectId: 'listettan-clicked-link',
      objectType: 'UIElement',
      title: 'standardEvent',
      target: {
        type: 'ClassifiedAd',
        id: props.adId,
        url: props.clickUrl,
        name: props.subject,
        category: ' ',
      },
    })
  }

  if (props.storeName || props.storeLogoUrl) {
    formattedAd.store = {}
    if (props.storeName) {
      formattedAd.store.name = props.storeName
    }
    if (props.storeLogoUrl) {
      formattedAd.store.logo = { url: props.storeLogoUrl }
    }
  }

  return (
    <ListItem
      ad={formattedAd}
      url={props.clickUrl}
      imageSrc={props.imageUrl}
      adParams={props.description}
      onClick={trackClick}
    />
  )
}

ToplistAdItem.propTypes = {
  adId: PropTypes.string,
  categoryName: PropTypes.string,
  location: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  subject: PropTypes.string.isRequired,
  productLabel: PropTypes.string,
  impressionUrl: PropTypes.string.isRequired,
  storeName: PropTypes.string,
  storeLogoUrl: PropTypes.string,
  description: PropTypes.array.isRequired,
  clickUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
}

export default ToplistAdItem
